module.exports = __webpack_public_path__ + "img/xcg4.7cb2a44e.jpg";